// extracted by mini-css-extract-plugin
export default {"inlineActionButton":"styles_inlineActionButton__MwW6i","sendMoneyButton":"styles_sendMoneyButton__GcX7D"};